import { useEffect } from 'react';
import { useQrStore } from '../../../../../store/use-qr-store';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLang } from '../../../../../hooks/use-lang';
import { validate } from '../../../../../helpers/validate';
import { validateLang } from '../../../../../helpers/lang';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { concatPath } from '../../../../../helpers/path';
import { ManagerPath, QrCodesPath, RootPath } from '../../../../../routes/manager/manager-enums';

export const useCreateQr = () => {
  const { postQr, isLoading, qr, handleResetQr, putQr, fetchQr } = useQrStore();
  const { fetchBranches } = useBranchesStore();
  const { t } = useLang();

  const [params] = useSearchParams();
  const id = params.get('id');

  useEffect(() => {
    if (id) fetchQr(id);
    fetchBranches({ is_by_company: true, since_id: 0, n: 1000 });

    return () => handleResetQr();
  }, [fetchBranches, fetchQr, handleResetQr, id]);

  const navigate = useNavigate();

  const handleNext = async () => {
    const isValid = validate({
      name: { rule: () => validateLang(qr?.name) },
      branch: { rule: () => !!qr?.place_id },
      tree: {
        rule: () => !!qr?.services?.includes('feedback') && (!!qr?.tree_id || !!qr.tree?.id),
      },
    });
    if (!isValid) return;

    if (id) {
      await putQr();
      window.history.back();
    } else {
      await postQr();
      navigate(concatPath([RootPath.Manager, ManagerPath.QrCodes, QrCodesPath.StaticList]));
    }
  };

  return {
    handleNext,
    isLoading,
    id,
    t,
  };
};
